import "./styles.less";

import { Avatar, Card, Col, Row } from "antd";
import { FC } from "react";
import Text from "antd/lib/typography/Text";
import { ImagenOptimizada } from "shared-components/Components/Image/_new_web";

interface OwnerProps {
	name: string;
	logo?: string;
}

export const Owner: FC<OwnerProps> = ({
	name,
	logo = null
}) => {
	return (
		<>
			<Card size="small" className="owner">
				<Row gutter={16} align="middle">
					<Col>
						{logo ? (
							<ImagenOptimizada src={logo} alt={name} width={110} height={50} />
						) : (
							<Avatar alt={name}>{name[0]?.toUpperCase()}</Avatar>
						)}
					</Col>
					<Col
						flex={1}
						className="left"
						style={{ overflow: "hidden", position: "relative" }}>
						<Text>{name}</Text>
					</Col>
				</Row>
			</Card>
		</>
	);
};

